import { AppLink } from "@base/ui/AppLink";
import { useLatestLocalDraftId } from "@features/draft/model/useLatestLocalDraftId";
import { Plus } from "lucide-react";
import type { DailyLogSearchRouteInput, DailyLogSearchRouteParams } from "../model/dailyLogSearchState";
import { DailyLogSearchPanel } from "./DailyLogSearchPanel";

interface ProjectDocumentsTabContentProps {
  projectId: string;
  searchParams: DailyLogSearchRouteParams;
  onSearchParamsChange: (params: DailyLogSearchRouteInput) => void;
}

export function ProjectDocumentsTabContent({
  projectId,
  searchParams,
  onSearchParamsChange,
}: ProjectDocumentsTabContentProps) {
  const latestLocalDraftId = useLatestLocalDraftId(Number(projectId));

  return (
    <div className="flex absolute inset-0 top-4 flex-col">
      <DailyLogSearchPanel
        projectId={Number(projectId)}
        routeParams={searchParams}
        onRouteParamsChange={onSearchParamsChange}
      />

      <AppLink
        to="/projects/$projectId/log/new"
        params={{ projectId }}
        search={latestLocalDraftId ? { draftId: latestLocalDraftId } : {}}
        // 모바일 전용. PC는 프로젝트 header의 "New Daily Log" 버튼을 쓴다.
        className="absolute right-0 bottom-0 bg-white shadow-sm rounded-circle p-[10px] text-blue-500 md:hidden"
        aria-label="New Document"
      >
        <Plus width={32} height={32} />
      </AppLink>
    </div>
  );
}
